/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}

function setCookie(cName, cValue, expDays) {
  let date = new Date();
  date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
  const expires = "expires=" + date.toUTCString();
  document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
}

(function(){

  let inputInterval = setInterval(function(){
    let productInput = document.querySelector("input[name='text-1']");
    if(productInput){
      productInput.value = window.custom_product.title;
      productInput.setAttribute("readonly", true);
      console.log("loading title!");
      setTimeout(function(){
        if(inputInterval){
          clearInterval(inputInterval);
          console.log("title set!");
        }
      },1500);
    }
  }, 100);
})();

var headerHeight = $('header').outerHeight();

function toggleIcon(e) {
    e.preventDefault();
    $(e.target)
        .prev('.panel-heading')
        .find(".more-less")
        .toggleClass('glyphicon-plus glyphicon-minus');

}

$(window).scroll(function() {
    if ($(this).scrollTop() > 50) {
        $('.Product__Info').addClass('scrollProduct');
    } else {
        $('.Product__Info').removeClass('scrollProduct');
    }
});

/**document.addEventListener('DOMContentLoaded', function () {

    
});*/

$(document).ready(function() {

    if(localStorage.getItem("show_ecom") === null || localStorage.getItem("show_ecom") !== "OK") {
      $('head').append("<style>section#section-template--25247764218236__background_video_v2_DpMeJ3 div.sliderbtns, div.ProductItem__PriceList, div.ProductMeta__PriceList, div.Header_cart_div, div.ProductForm__QuantitySelector, div.ProductForm__BuyButtons, div.Header_Wrap div.menu_right a[data-drawer-id=\"sidebar-cart\"] {display:none!important}</style>");

    } else {

      let chamoisine250 = { "en": "Receive a complimentary gift with all orders over €250.", "fr": "Recevez un cadeau pour toute commande supérieure à 250 €.", "de": 'Erhalten Sie bei allen Bestellungen über 250 € ein kostenloses Geschenk.', "it": "Ricevi un regalo omaggio con tutti gli ordini superiori a 250 €." };
      const lang = window.Shopify.locale;
      if(lang === undefined) {
        urlLang = window.location.pathname.split("/")[1];
        if(urlLang === 'de') lang = "de";
        if(urLang === 'en') lang = 'en';
      }
      $("div.ProductForm__BuyButtons").after('<div class="ProductForm__Inventory bold" style="text-align: center; align-items: center;font-weight:500;margin-bottom:0!important;">'+chamoisine250[lang]+'</div>');
    }

    var sneaker_slider = $('.sneaker-slider');
    sneaker_slider.on('init', function(event, slick) {
        $('.sneaker-slider-wpr').addClass('show-slider');
    });
    sneaker_slider.slick({
      autoplay: false,
      speed: 1500,
      pauseOnHover: false,
      lazyLoad: 'progressive',
      arrows: false,
      dots: false,
    }).slickAnimation();

    var sneakercollectionslider = $('.sneaker-collection-slider');
    sneakercollectionslider.on('init', function(event, slick) {
      // sneakercollectionslider.css('visibility', 'visible');
       $('.sneaker-collection-slider-wpr').removeClass('hide-slider');
    });
    sneakercollectionslider.slick({
        autoplay: false,
        slidesToShow: 4,
        slidesToScroll: 2,
        speed: 400,
        cssEase: 'linear', 
        infinite: true,
        pauseOnHover: false,
        arrows: false,
        dots: false,
        touchThreshold: 4,
        touchMove: true,
        draggable: true,
        swipe: true,
        responsive: [
        {
            breakpoint: 992,
            settings: {
            slidesToShow: 2,
            arrows: true,
            swipeToSlide: true,
            }
        },
        {
            breakpoint: 576,
            settings: {
            slidesToShow: 1,
            // arrows: true,
            swipeToSlide: true,
            }
        },
        ]
    });
       new WOW().init();

    var activePos = $('.tab-wrap .active').position();

    function changePos() {
        activePos = $('.tab-wrap .active').position();
        if (activePos) {
            $('.border').stop().css({
                left: activePos.left,
                width: $('.tab-wrap .active').width()
            });
        }
    }

    changePos();

    function changeTab() {
        var getTabId = $('.tab-wrap .active a').attr('tab-id');

        $('.tab').stop().fadeOut(300, function() {
            $(this).removeClass('active');
        }).hide();

        $('.tab[tab-id=' + getTabId + ']').stop().fadeIn(300, function() {
            $(this).addClass('active');
            animateTabHeight();
        });
    }

    $('.tab-wrap .tab-slider__heading-item').on('click', function(e) {
        e.preventDefault();
        var tabId = $(this).attr('tab-id');

        $('.tab-wrap .tab-slider__heading-item').stop().parent().removeClass('active');

        $(this).stop().parent().addClass('active');

        changePos();

        tabCurrentItem = tabItems.filter('.active');

        $('.tab').stop().fadeOut(300, function() {
            $(this).removeClass('active');
        }).hide();

        $('.tab[tab-id="' + tabId + '"]').stop().fadeIn(300, function() {
            $(this).addClass('active');
            animateTabHeight();
        });
    });

    var tabItems = $('.tab-wrap .heading_item');
    var tabCurrentItem = tabItems.filter('.active');

    var deviceWidth = $(window).width();

    /*  if(deviceWidth < 1008){
          // if(window.location.hash == "#filter_collection" && document.querySelector(`${window.location.hash}`)){
        if(document.querySelector("#subcollection-mobile-filter-drawer")){
              setTimeout(function(){
                  //window.scrollTo(0 , document.querySelector("#filter_collection").offsetTop - (document.querySelector("#shopify-section-announcement").offsetHeight + document.querySelector("#shopify-section-header").offsetHeight));
                  window.scroll({ top: document.querySelector("#filter_collection").offsetTop - (document.querySelector("#shopify-section-announcement").offsetHeight + document.querySelector("#shopify-section-header").offsetHeight), behavior: 'smooth' });
                  console.log("Done!")
              }, 500);
          }
      }*/
    $("ul.ColorSwatchList").click(function() {
        $(".template-product").addClass("swatch-popup-open");
        //     $(".ColorSwatchListPopup").addClass("fade-in-right");
        $(".ColorSwatchListPopup").show();
        let windowWidth = $(window).width();
      $(".Product__Variants-list-custom").css("display", "block");
        // if (windowWidth > 768) {
        //     $(".ColorSwatchListPopup").addClass("fade-in-right");
        //     $(".Product__Variants-list-custom").css("display", "block");
        // } else {
        //     $(".Product__Variants-list-custom").addClass("fade-in-right");

        // }
        $("body").addClass("fullSizeBody");
        //$(".Product__Slideshow .Product__SlideItem").first().addClass("fixHieghtForProduct");
        // $(".Product__Slideshow .Product__SlideItem").first().addClass("fixFullWidthHieght");
        $(".Product__Slideshow").first().addClass("fixFullWidthHieght");

        $('html, body').animate({
            scrollTop: 0
        }, 0);
        //     if(deviceWidth > 600 ){

        //     }else{
        //      //$(".Product__MobileWrapper").show();
        //     }
    });

    $(".ColorSwatchListClose").click(function() {

        $(".template-product").removeClass("swatch-popup-open");
        $(".ColorSwatchListPopup").removeClass("fade-in-right");
        $(".ColorSwatchListPopup").hide();
        let windowWidth = $(window).width();
        if (windowWidth > 768) {
            $(".ColorSwatchListPopup").removeClass("fade-in-right");
            $(".Product__Variants-list-custom").css("display", "block");
        } else {
            $(".Product__Variants-list-custom").removeClass("fade-in-right");

        }
        $("body").removeClass("fullSizeBody");
        //$(".Product__Slideshow .Product__SlideItem").first().removeClass("fixHieghtForProduct");
        $(".Product__Slideshow").first().removeClass("fixFullWidthHieght");

    });

    /*$(".Close_Megamenu").click(function(e){
      e.preventDefault();
      $(this).parent().attr('aria-hidden','true');
      $(this).parent().parent().removeClass('is-expanded');
    });*/
    if($("body").hasClass("template-product") == true) {

        var url = window.location.href;
        var dataJSON = JSON.parse($("script[data-product-json='']").html());
        var variantValue = window.location.search;
        var VaraintIDArray = variantValue.split('=');

        if (window.location.href.indexOf("#") > -1) {

            $.each(dataJSON.product.variants, function(key, value) {
                if (value.id == VaraintIDArray[1]) {
                    console.log(key);
                    console.log(value);
                    var featured_media_id_scroll = value.featured_media.id;
                    scrollToIdTop = "Media" + featured_media_id_scroll;

                    if ($(".Product__SlideshowNavDot[href='#" + scrollToIdTop + "']").length > 0) {
                        $(".Product__SlideshowNavDot").removeClass("is-selected");
                        $(".Product__SlideshowNavDot[href='#" + scrollToIdTop + "']").addClass("is-selected");

                        $(".Product__SlideshowNavImage").removeClass("is-selected");
                        $(".Product__SlideshowNavImage[href='#" + scrollToIdTop + "']").addClass("is-selected");

                        $(".Product__SlideshowNavDot[href='#" + scrollToIdTop + "']")[0].click();
                    }
                }
            });
        }
    }
    //load the colour swaches name

    $(".Product__SlideItem .assign_colour_name").each(function() {
        var imageMediaId = $(this).data('media-id');
        $.each(dataJSON.product.variants, function(key, value) {
            if (value.featured_media != null) {
                if (imageMediaId == value.featured_media.id) {
                    $(".assign_colour_name[data-media-id='" + value.featured_media.id + "']").attr('data-colour', value.title);
                }
            }
        });
    });

    $(".Product_coming_soon .ColorSwatch__Radio").click(function() {

        variantColor = $('input:radio[class=ColorSwatch__Radio]:checked').val();
        var data = JSON.parse($("script[data-product-json='']").html());

        $.each(data.product.variants, function(key, value) {
            if (value.title == variantColor) {
                featured_media_id = value.featured_media.id;
                scrollToId = "Media" + featured_media_id;
                if ($(".Product__SlideshowNavDot[href='#" + scrollToId + "']").length > 0) {
                    $(".Product__SlideshowNavDot").removeClass("is-selected");
                    $(".Product__SlideshowNavDot[href='#" + scrollToId + "']").addClass("is-selected");

                    $(".Product__SlideshowNavImage").removeClass("is-selected");
                    $(".Product__SlideshowNavImage[href='#" + scrollToId + "']").addClass("is-selected");

                    $(".Product__SlideshowNavDot[href='#" + scrollToId + "']")[0].click();

                    $(".flickity-page-dots .dot").removeClass("is-selected");
                    $(".flickity-page-dots .dot[data-media-id='" + featured_media_id + "']")[0].click();
                    $(".flickity-page-dots .dot[data-media-id='" + featured_media_id + "']").addClass("is-selected");

                } else if ($("a.Product__SlideshowNavImage[data-media-id='" + featured_media_id + "']").length > 0) {
                    console.log("in else if 1");
                    $(".Product__SlideshowNavImage[data-media-id='" + featured_media_id + "']")[0].click();
                }

            }
        });
    });

    $(document).on("click", ".Product_coming_soon .ColorSwatch__Radio", function() {
        var clickVal = $(this).val();
        $(".ProductForm__SelectedValue").html(clickVal);
    });

    /*var radioSelectedId = 1;
    
    $(".Product_coming_soon .ColorSwatch").click(function(){
      console.log("click");
       var radioSelectedId = $(this).data('indexid');   
    });*/

    //console.log(radioSelectedId);
    /*
  $(".Product_coming_soon .flickity-slider .Product__SlideItem").each(function(){
    $(this).removeClass('is-selected');
    var media_position = $(this).data('image-media-position');
    if(media_position == radioSelectedId){
        $(this).addClass('is-selected');
    }
  });
  $(".Product_coming_soon .flickity-page-dots").each(function(){
    $(this).removeClass('is-selected');
    var index_position = $(this).data('index');
    if(index_position == radioSelectedId){
      $(this).addClass('is-selected');
    }
  });*/


    //var options = {};
    // $( ".header_guide_menu a" ).effect( 'slide', options, 500, callback );
    $('.productslider').not('.slick-initialized').slick({
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        speed: 600,
        infinite: false,
        dots: true,
        responsive: [{
                breakpoint: 1400,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: true
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: true,
                    dots: true
                }
            },
            {
                breakpoint: 650,
                settings: {
                    centerMode: true,
                    centerPadding: '0%',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: true
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });

    // Get the current slide
    var currentSlide = $('.productslider').slick('slickCurrentSlide');

    // Add a class to identify that the user is seeing the first slide
    $('.productslider').addClass('first-slide-is-active');

    // Change or add that class when there is slider movement
    $('.productslider').on('afterChange', function(event, slick, currentSlide) {
        if (currentSlide === 0) {
            // Add the class back if back in the first slide
            $('.productslider').addClass('first-slide-is-active');
        } else {
            // Remove the class
            $('.productslider').removeClass('first-slide-is-active');
        }
    });

    $(".topLink").on('click', function(event) {
        event.preventDefault();
        var e = $(this); //writing $(this) every time is bad
        t = $("div[data-target='" + e.attr('data-target') + "']"); //same as above

        if (e.hasClass('active')) {
            console.log("in if");
            e.removeClass("active");
            //close box    
            t.slideUp("slow");
        } else { //toggle menu when clicking on some other link
            //remove from everywhere
            console.log("in else");
            $(".topLink").removeClass('active');
            //slide every box up
            $('.toggles').slideUp("slow");
            //add to this only
            e.addClass('active');
            //slide associated box down
            t.slideDown("slow");
        }
    });

    $('.panel-group').on('hidden.bs.collapse', toggleIcon).slideUp("slow");
    $('.panel-group').on('shown.bs.collapse', toggleIcon).slideDown("slow");
  
    // Show modal on click
    $(".informodal").on('click', function () {
        $('#myModal').css({
            "opacity": "1",
            "pointer-events": "auto"
        }).show();
    });

    $(".close").on('click', function() {
        $("#myModal").css({
            "opacity": "0",
            "pointer-events": "none"
        });
        $("#mymModal").css({
            "opacity": "0",
            "pointer-events": "none"
        });
    });

    // Close modal when clicking outside the modal content
    $(document).on('click', function (e) {
        if (!$(e.target).closest('#myModal .modal-content, .informodal, .close').length) {
            $('#myModal').css({
                "opacity": "0",
                "pointer-events": "none"
            }).hide();
        }
    });

    var fix_header_height = ($(".supports-sticky .section-header .Header__Wrapper").length > 0) ? $(".supports-sticky .section-header .Header__Wrapper").height() : 0;
    $('.header_guide_menu a[href*=\\#]:not([href=\\#])').on('click', function() {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.substr(1) + ']');
        if (target.length) {
            $('html,body').animate({
                scrollTop: target.offset().top - (fix_header_height + 145)
            }, 500);
            return false;
        }
    });

    $('.commonslider').not('.slick-initialized').slick({
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 600,
        infinite: false,
        responsive: [{
                breakpoint: 1400,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true

                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 2,
                    arrows: true

                }
            },
            {
                breakpoint: 650,
                settings: {
                    centerMode: true,
                    centerPadding: '0%',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });

    // Get the current slide
    var currentSlide = $('.commonslider').slick('slickCurrentSlide');

    // Add a class to identify that the user is seeing the first slide
    $('.commonslider').addClass('first-slide-is-active');

    // Change or add that class when there is slider movement
    $('.commonslider').on('afterChange', function(event, slick, currentSlide) {
        if (currentSlide === 0) {
            // Add the class back if back in the first slide
            $('.commonslider').addClass('first-slide-is-active');
        } else {
            // Remove the class
            $('.commonslider').removeClass('first-slide-is-active');
        }
    });

    /*$('.bxsliderSliderShow').bxSlider({
          auto: false,
          //autoControls: true,
          //stopAutoOnClick: true,
          pager: false,
              swipeThreshold:50,
            touchEnabled:false,
              preventDefaultSwipeX:false//,
          //slideWidth: 600
        });*/
    /*$('.bxsliderSliderShow').bxSlider({
      auto: false,
      //autoControls: true,
      //stopAutoOnClick: true,
      pager: false,
      swipeThreshold:50,
      touchEnabled:true,
      sliderDirection:"horizontal",
        oneToOneTouch:false, 
        preventDefaultSwipeX:false, 
     // preventDefaultSwipeX:false//,
      //slideWidth: 600
    });*/

    /*$(document).on("click", ".sidebar-collapsible", function(){
      if($(this).attr("aria-expanded") == "true"){
        $(this).next(".Collapsible__Inner").find(".Collapsible__Button ").each(function(){
          $(this).next(".Collapsible__Inner").slideDown("slow");
          $(this).attr("aria-expanded", "true");
          
        });
      }else{
        console.log("else");
        $(this).next(".Collapsible__Inner").find(".Collapsible__Button ").each(function(){
          $(this).next(".Collapsible__Inner").slideUp("slow");
          $(this).attr("aria-expanded", "false");
          
        });
      }
    });*/
    $(".ProductMeta__MoreInformation a").click(function() {
        $("html, body").animate({
            scrollTop: $("#ProductAside").offset().top - 160 // Scroll to the target div while accounting for the reduced header height
        }, 500);
    });

    $(document).on("click", ".sidebar-collapsible", function() {
        if ($(this).attr("aria-expanded") == "true") {
            $(this).next(".Collapsible__Inner").find(".Collapsible").each(function() {
                $(this).css("overflow", "visible");
                $(this).find(".Collapsible__Button").attr("aria-expanded", "true");
                $(this).find(".Collapsible__Inner").css("overflow", "visible");

                $box = $(this).find(".Collapsible__Inner")
                currentHeight = $box.innerHeight();
                autoHeight = $box.css('height', 'auto').innerHeight();
                $box.css('height', currentHeight).animate({
                    height: autoHeight
                });
                $box.css('height', 'auto');
            });
        } else {
            $(this).next(".Collapsible__Inner").find(".Collapsible").each(function() {
                $(this).css("overflow", "hidden");
                $(this).find(".Collapsible__Button").attr("aria-expanded", "false");
                $(this).find(".Collapsible__Inner").css("overflow", "hidden");
                $(this).find(".Collapsible__Inner").css("height", "0");
            });
        }
    });


    $(".tablist .TabPanel").first().attr("aria-hidden", "true");
    $(".TabPanel").not(':first').attr("aria-hidden", "false");



    $(".TabList__Item").click(function() {
        var ariaID = $(this).attr('aria-controls');
        $(".TabPanel").attr("aria-hidden", "true");
        $("#" + ariaID + "").attr("aria-hidden", "false");
        $(".TabList__Item").removeClass("is-active");
        $(this).addClass("is-active");
        $("[data-drawer-id='subcollection-mobile-filter-drawer']")[0].click();
        // window.scrollTo(0,0);
        window.scroll({ top: document.querySelector("#filter_collection").offsetTop - (document.querySelector("#shopify-section-announcement").offsetHeight + document.querySelector("#shopify-section-header").offsetHeight), behavior: 'smooth' });
    });

    $(".allsubcat.TabList__Item").click(function() {
        $(".TabPanel").attr("aria-hidden", "false");
    });

    let popupOpener = document.querySelector(".subscribe_btn");
    if (popupOpener) {
        popupOpener.addEventListener("click", function() {
            if ($(".successPopup").length > 0) {
                $(".NewsletterPopup").removeClass('successPopup');
                $(".info_title").css('display', 'none');
                $(".info_content").css('display', 'none');
                $(".cmApp_signupFormWrapper").css('display', 'block');
            }
            document.querySelector("#shopify-section-subscribe-popup .NewsletterPopup").setAttribute('aria-hidden', 'false');
            document.querySelector("#shopify-section-subscribe-popup .Custom_popup-wrapper").classList.add('popup-active');
        });
    }

    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return false;
    };
    var subscribeVal = getUrlParameter('customer_posted');
    if (subscribeVal == 'true') {
        $(".NewsletterPopup").addClass('successPopup');
        $(".successPopup").css('max-width', '400px');
        $("#shopify-section-subscribe-popup .NewsletterPopup").attr('aria-hidden', 'false');
        $(".cmApp_signupFormWrapper").css('display', 'none');
        $(".info_title").css('display', 'block');
        $(".info_content").css('display', 'block');
        $(".Custom_popup-wrapper").addClass('popup-active');
        /* toastr.options = {
          "closeButton": true,
          "debug": false,
          "newestOnTop": false,
          "progressBar": true,
          "positionClass": "toast-top-center",
          "preventDuplicates": false,
          "onclick": null,
          "showDuration": "300",
          "hideDuration": "1000",
          "timeOut": "1500",
          "extendedTimeOut": "1000",
          "showEasing": "swing",
          "hideEasing": "linear",
          "showMethod": "fadeIn",
          "hideMethod": "fadeOut"
        }
    
        toastr.success('Thank you for subscribing!', "Thank you");*/
    }
});